import {
  Box, IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay, Stack, Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs, Text, useColorModeValue
} from "@chakra-ui/react";
import { ContatoType } from "models/contato_type";
import { OrderType } from "models/order_type";
import { MdCheck } from "react-icons/md";
import OrderValue from "./OrderCalc";
import OrderHeader from "./OrderHeader";
import OrderItems from "./OrderItems";

interface IAprovedForm {
  showModal: (show: boolean, item: OrderType) => void;
  show: boolean;
  accountSelected: OrderType;
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
  approve: (type: string) => void;
  reprove: (type: string) => void;
  update: () => void;
  cabecalhoAprovado: boolean;
  calculoAprovado: boolean;
  itensAprovado: boolean;
}

const ApprovedForm = ({
  showModal,
  show,
  accountSelected,
  contatoAgencia,
  contatoCliente,
  approve,
  reprove,
  cabecalhoAprovado,
  calculoAprovado,
  itensAprovado,
  update
}: IAprovedForm) => {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  return (
    <Box>
      <Box>
        <Tabs isFitted variant="enclosed" colorScheme={"brand"}>
          <TabList mb="1em">
            <Tab>Revisão dos Dados do Orçamento</Tab>
            <Tab>Aprovação dos Itens do Orçamento</Tab>
            <Tab>Aprovação do Cálculo do Orçamento</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <OrderHeader
                accountSelected={accountSelected}
                textColor={textColor}
                contatoAgencia={contatoAgencia}
                contatoCliente={contatoCliente}
                approve={approve}
                reprove={reprove}
                cabecalhoAprovado={cabecalhoAprovado}
              />
            </TabPanel>
            <TabPanel>
              <OrderItems
                accountSelected={accountSelected}
                approve={approve}
                reprove={reprove}
                itensAprovados={itensAprovado}
              />
            </TabPanel>
            <TabPanel>
              <OrderValue accountSelected={accountSelected}

                approve={approve}
                reprove={reprove}
                calculoAprovado={calculoAprovado}
              />
              {
                calculoAprovado && itensAprovado && cabecalhoAprovado && (
                  <Box mb={"32px"} flexDirection={"row"}>
                    <Stack direction={["column", "row"]} spacing="24px">


                      <Text color={"black"} fontWeight={"bold"} mt={12} float={'right'}>
                        Seguir para o Lançamento do Projeto?
                      </Text>

                    </Stack>
                    <IconButton
                      colorScheme='green'
                      float={'right'}
                      size={'lg'}
                      mt={-12}
                      aria-label='Search database'
                      icon={<MdCheck />}
                      onClick={() => { update() }}
                    />
                  </Box>
                )
              }
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};
export default ApprovedForm;
